import { NgModule } from "@angular/core";
import { ValuationComparablesComponent } from "./valuation-comparables.component";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { CdkAccordionModule } from "@angular/cdk/accordion";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { ComparableFilterDialogComponent } from "./filter-dialog/comparable-filter-dialog.component";
import { ValuationComparableService } from "src/app/core/valuation-process/_services/valuation-comparable.service";
import { ComparableListStore } from "./core/comparable-list.store";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,

        CdkAccordionModule,
        ScrollingModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        NgbPopoverModule,
        NgxMaskPipe
    ],
    exports: [
        ValuationComparablesComponent
    ],
    declarations: [
        ValuationComparablesComponent,
        ComparableFilterDialogComponent
    ],
    providers: [
        provideNgxMask(),
        ValuationComparableService,
        // Module-scoped so the table's query state survives leaving and re-entering the tab.
        ComparableListStore
    ]
})
export class ValuationComparablesModule {}
